module.exports = __webpack_public_path__ + "fonts/GothamPro-Bold.2d2bd971.woff2";